import { Box, makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  containerButtons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: theme.spacing(2, 0),
    width: '95%',
  },
}));
function SkeletonContainerVideo() {
  const classes = useStyles();
  return (
    <Box>
      <Box>
        <Skeleton variant="rect" width="95%" height={470} />
      </Box>
      <Box className={classes.containerButtons}>
        <Skeleton variant="rect" width={180} height={45} />
        <Skeleton variant="rect" width={180} height={45} />
        <Skeleton variant="rect" width={180} height={45} />
      </Box>
      <Skeleton variant="rect" width="95%" height={80} />
      <Skeleton variant="rect" width="95%" height={170} />
    </Box>
  );
}

export default SkeletonContainerVideo;
